import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  IConnectExternalChannel,
  IOpenSsoAdminPortal,
  ISetLastViewedAlert,
  ICreateCustomerPortalSessionPayload,
  IUpdateProfilePayload,
  IChangeAvatarPayload,
} from './types'

import {
  ISetCurrentAccountPayload,
} from '@SiteModules/Account/types'

import {
  ISetCurrentWorkspacePayload,
} from '@SiteModules/Workspace/types'

const config: AxiosRequestConfig = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  responseType: 'json'
}

export function logout() {
  return axios.delete('/users/sign_out', config)
}

export function getUserInfo() {
  return axios.get('/api/v1/users/', config)
}

export function connectExternalChannel(data: IConnectExternalChannel) {
  return axios.post('/api/v1/external_channels/connect', data, config)
}

export function createCustomerPortalSession(payload: ICreateCustomerPortalSessionPayload) {
  return axios.get('/api/v1/users/create_customer_portal_session', { params: convertToSnakeCase(payload) })
}

export function openSsoAdminPortal(data: IOpenSsoAdminPortal) {
  return axios.post('/api/v1/sso/open_admin_portal', convertToSnakeCase(data), config)
}

export function setLastViewedAlert(data: ISetLastViewedAlert) {
  return axios.put('/api/v1/users/set_last_viewed_alert', convertToSnakeCase(data), config)
}

export function setLastUsedAccount(payload: ISetCurrentAccountPayload) {
  return axios.put('/api/v1/users/set_last_used_account', convertToSnakeCase(payload), config)
}

export function setLastUsedWorkspace(payload: ISetCurrentWorkspacePayload) {
  return axios.put('/api/v1/users/set_last_used_workspace', convertToSnakeCase(payload), config)
}

export function resetShouldSeeNewsletterPopup() {
  return axios.put('/api/v1/users/reset_should_see_newsletter_popup', {}, config)
}

export function updateProfile(payload: IUpdateProfilePayload) {
  return axios.put(`/api/v1/users/update_profile`, convertToSnakeCase(payload), config)
}

export function changeAvatar(payload: IChangeAvatarPayload) {
  return axios.post(`/api/v1/users/change_avatar`, convertToSnakeCase(payload), config)
}
